import { ESystemLanguage } from '@flecto/types'

const en = new Map([
  [ESystemLanguage.EN, '🇬🇧 English'],
  [ESystemLanguage.PT, '🇵🇹 Portuguese'],
  [ESystemLanguage.ES, '🇪🇸 Spanish'],
])

const pt = new Map([
  [ESystemLanguage.EN, '🇬🇧 Inglês'],
  [ESystemLanguage.PT, '🇵🇹 Português'],
  [ESystemLanguage.ES, '🇪🇸 Espanhol'],
])

const es = new Map([
  [ESystemLanguage.EN, '🇬🇧 English'],
  [ESystemLanguage.PT, '🇵🇹 Portuguese'],
  [ESystemLanguage.ES, '🇪🇸 Español'],
])

export const i18n = new Map([
  [ESystemLanguage.EN, en],
  [ESystemLanguage.PT, pt],
  [ESystemLanguage.ES, es],
])
